//store representing the current tag(s)
import { defineStore } from 'pinia'
import type { Tag } from '../types/types'
import { useProjectStore } from '@/stores'
import { storeToRefs } from 'pinia'

function onlyUnique(value, index, array){
  return array.indexOf(value) === index;
}

//TODO this should just read, write, delete an entire tag, backend does the work
export const useTagStore = defineStore('tags', () => {
  
  /**
   * return all tags
   * UPDATE: read all tags assigned to projects currently
   * @returns
   */
  async function getAll() {
    console.log('tag store.getAll()....fetching from api/backend...')
    try {
      //get all unique tags assigned to projects
      const projectStore = useProjectStore();
      const { allProjects } = storeToRefs(projectStore);
     // const allProjects = await projectStore.getAll();
      const allTags = allProjects.value.map(proj =>{
       // console.log(proj.tags);
        if(proj.tags.length>0){
          return proj.tags;
        }else{
          return [];
        }
      }).flat()
      .filter(onlyUnique).sort();
     //console.log("allTags= " + allTags);
      return allTags;
/*
      const response = await axios.get('/tags')
      //const response = await axios.get('http://127.0.0.1:3000/tags');
      console.log('response from backend is:...')
      console.log(response)
      return response.data.data.tags*/
    } catch (error) {
      console.error(error)
    }
    return [{ id: 'empty', name: 'nothing found' }]
  }

  /**
   * return a tag from its id
   * @returns
   */
  async function getById(id: Number) {
    console.log(`tag store.getById(${id})....fetching from api/backend...`)
    try {
      const allTags = await getAll();
      return allTags.filter(tag =>{
        return tag.id == id;
      })[0];

      /*const response = await axios.get(`/tags/${id}`)
      //const response = await axios.get('http://127.0.0.1:3000/tags');
      console.log('response from backend is:...')
      console.log(response)
      const tag = response.data.data.tag
      //let tagInfo = tag;
      //delete tagInfo['Invoices'];
      //delete tagInfo['Postech'];

      return tag*/
    } catch (error) {
      console.error(error)
    }
    return { id: 'empty', name: 'nothing found' }
  }

  /**
   * add a new tag
   */
  async function add(obj: Tag) {
    console.log('tag store adding new tag : ' + obj.name)
    try {
      const response = await axios.post('/tags', obj)
      console.log('response from backend:')
      console.log(JSON.stringify(response))
      return response.data.message
    } catch (error) {
      console.log(error)
    }
    // router.push('/customers');
  }

  return { getAll, getById, add }
})
